import { ElementDetails } from "@/lib/types";
import { MeetingsProps } from "./types";

export const details = {
  name: "Meetings",
  description: "A widget to display your events in a schedule view",
  tags: ["Productivity", "Organization"],
  category: "Widget",
  grid: { small: [2, 2], medium: [3, 3] },
  integrationsUsed: ["google"],
  integrationScopes: { google: ["calendar"] },
  defaultProps: {
    pageSize: 10,
    from: "",
    useGradient: true,
  },
} satisfies ElementDetails<MeetingsProps>;
